import React, { useState, useEffect } from "react";
import block from "bem-css-modules";
import Select from "../../components/Utility/Select";
import button from "../../styles/components/Button.module.scss";
import disclaimer from "../../styles/components/Disclaimerform.module.scss";
import { t } from "../../helpers/common";

export default function DisclaimerForm({
  spaceTop,
  spaceBottom,
  column,
  disclaimerData,
}) {
  block.setSettings({
    modifierDelimiter: "--",
  });

  const [isError, setIsError] = useState(false);
  const [firstValue, setFirstValue] = useState(0);
  const [secondValue, setSecondValue] = useState(0);

  const data = [
    { id: 1, label: "Sweden" },
    { id: 2, label: "United States of America" },
    { id: 3, label: "Canada" },
    { id: 4, label: "Japan" },
    { id: 5, label: "South Africa" },
    { id: 6, label: "Austraila" },
    { id: 7, label: "Other Countries" }
  ];

  const dataList = [
    { id: 1, label: "Sweden" },
    { id: 2, label: "United States of America" },
    { id: 3, label: "Canada" },
    { id: 4, label: "Japan" },
    { id: 5, label: "South Africa" },
    { id: 6, label: "Austraila" },
    { id: 7, label: "Other Countries" }
  ];

  const btn = block(button);
  const form = block(disclaimer);

  const handleSelect1 = (id) => {
    setFirstValue(id);
  };

  const handleSelect2 = (id) => {
    setSecondValue(id);
  };

  return (
    <div
      className={
        `${form("")}` +
        " " +
        `${spaceTop && disclaimer["disclaimer--spaceTop"]}` +
        " " +
        `${spaceBottom && disclaimer["disclaimer--spaceBottom"]}`
      }
    >
      <div
        className={
          `${form("wrapper")}` + " " + `${column && form(`wrapper--${column}`)}`
        }
      >
        <Select
          list={data}
          label={disclaimerData?.Form?.FirstInputText || ""}
          onChange={handleSelect1}
        />
        <Select
          list={dataList}
          label={disclaimerData?.Form?.SecondInputText || ""}
          onChange={handleSelect2}
        />

        {firstValue == 0 || secondValue == 0 ? (
          <>
            <a
              className={
                `${btn("", { primary: true, noTransform: true })}` +
                " " +
                `${form("cta")}`
              }
              onClick={() => setIsError(true)}
            >
              {" "}
              {disclaimerData?.Form?.ButtonText || ""}{" "}
            </a>

            {isError && (
              <p className={form("error")}>Please select the fields</p>
            )}
          </>
        ) : (
          <></>
        )}

        {firstValue == 1 && secondValue == 1 ? (
          <a
            href={
              t("lang_route:investors.content.disclaimer") + "?approved=true"
            }
            className={
              `${btn("", { primary: true, noTransform: true })}` +
              " " +
              `${form("cta")}`
            }
          >
            {" "}
            {disclaimerData?.Form?.ButtonText || ""}{" "}
          </a>
        ) : (
          <></>
        )}

        {firstValue != 1 || secondValue != 1 ? (
          firstValue != 0 && secondValue != 0 ? (
            <p className={form("error")}>
              {disclaimerData?.Form?.ErrorText || ""}
            </p>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
